/* cl-pdp (atolea): vida do buybox copiado do Prestige dele (snippet cl-pd01 no bloco cl_pdp).
   - variantes: radios [data-cl-opt] -> variante do JSON do produto -> input[name=id] do form
     NATIVO do buy_buttons (form unico), precos, rotulo "Select Color: X", ATC/estoque e foto.
   - galeria: miniaturas e bolinhas rolam o trilho (scroll-snap); o trilho atualiza as bolinhas. */
(function () {
  function money(cents) {
    var fmt = (window.Shopify && Shopify.money_format) || document.documentElement.getAttribute('data-cl-money') || '';
    var v = (cents / 100).toFixed(2), parts = v.split('.');
    var comma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var dot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    if (!fmt) return 'R$ ' + comma;
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
              .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0])
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
              .replace(/\{\{\s*amount\s*\}\}/, dot);
  }

  function init(host) {
    if (host.__clPdp) return; host.__clPdp = true;
    var jsonEl = host.querySelector('[data-cl-product-json]');
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var form = document.getElementById(host.getAttribute('data-form-id'));
    var idInput = form && form.querySelector('[name="id"]');

    function current() {
      var opts = [];
      host.querySelectorAll('[data-cl-picker]').forEach(function (pk) {
        pk.querySelectorAll('input[data-cl-opt]:checked').forEach(function (r) { opts[+r.getAttribute('data-cl-opt') - 1] = r.value; });
      });
      if (!product) return null;
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; });
      }) || null;
    }

    function apply(v) {
      if (!v) return;
      if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      host.querySelectorAll('[data-cl-price]').forEach(function (el) {
        var sr = el.querySelector('.sr-only'); el.textContent = ''; if (sr) el.appendChild(sr); el.appendChild(document.createTextNode(money(v.price)));
      });
      host.querySelectorAll('[data-cl-compare]').forEach(function (el) {
        var sr = el.querySelector('.sr-only'); el.textContent = ''; if (sr) el.appendChild(sr);
        if (v.compare_at_price && v.compare_at_price > v.price) el.appendChild(document.createTextNode(money(v.compare_at_price)));
      });
      host.querySelectorAll('[data-cl-optval]').forEach(function (el) {
        el.textContent = v.options[+el.getAttribute('data-cl-optval') - 1] || '';
      });
      host.querySelectorAll('[data-cl-atc]').forEach(function (b) {
        b.disabled = !v.available;
        var t = b.childNodes.length === 1 && b.firstChild.nodeType === 3;
        if (t) b.textContent = v.available ? 'ADD TO CART' : 'SOLD OUT';
      });
      if (v.featured_media) go(mediaIndex(v.featured_media.id));
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
    }

    host.addEventListener('change', function (e) {
      if (e.target.matches('input[data-cl-opt]')) apply(current());
    });

    /* galeria */
    var track = host.querySelector('.product-gallery__carousel');
    var slides = track ? Array.prototype.slice.call(track.children).filter(function (c) { return c.classList.contains('product-gallery__media'); }) : [];
    function mediaIndex(id) {
      for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute('data-media-id') == id) return i;
      return -1;
    }
    function mark(i) {
      host.querySelectorAll('[data-cl-thumb]').forEach(function (b) { b.setAttribute('aria-current', +b.getAttribute('data-cl-thumb') === i ? 'true' : 'false'); });
      host.querySelectorAll('.page-dots').forEach(function (nav) {
        Array.prototype.forEach.call(nav.querySelectorAll('button'), function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      });
    }
    function go(i) {
      if (!track || i < 0 || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      mark(i);
    }
    host.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cl-thumb]');
      if (t) { e.preventDefault(); go(+t.getAttribute('data-cl-thumb')); return; }
      var d = e.target.closest('.page-dots button');
      if (d) { e.preventDefault(); go(Array.prototype.indexOf.call(d.parentNode.querySelectorAll('button'), d)); }
    });
    if (track) {
      var raf = 0;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var x = track.scrollLeft, best = 0, bd = Infinity;
          slides.forEach(function (s, i) { var d = Math.abs(s.offsetLeft - slides[0].offsetLeft - x); if (d < bd) { bd = d; best = i; } });
          mark(best);
        });
      }, { passive: true });
    }

    /* safe-sticky do Prestige dele: na rolagem ele REESCREVE style.top com o valor da regra do tema
       (calc(var(--sticky-area-height) + 20px)), por cima de qualquer top inline. Mesmo comportamento aqui. */
    var stickies = host.querySelectorAll('cl-safe-sticky');
    function safeSticky() {
      stickies.forEach(function (el) { el.style.removeProperty('top'); el.style.top = getComputedStyle(el).top; });
    }
    if (stickies.length) { window.addEventListener('scroll', safeSticky, { passive: true }); window.addEventListener('resize', safeSticky); }

    /* ?variant= na URL vale tambem para o form nativo */
    if (product && idInput) {
      var q = new URLSearchParams(location.search).get('variant');
      var v0 = q && product.variants.find(function (v) { return String(v.id) === q; });
      if (v0) {
        v0.options.forEach(function (o, i) {
          host.querySelectorAll('input[data-cl-opt="' + (i + 1) + '"]').forEach(function (r) { r.checked = r.value === o; });
        });
        apply(v0);
      } else { var c = current(); if (c) idInput.value = c.id; }
    }
  }

  function boot() { document.querySelectorAll('[data-cl-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
